/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2019/3/6 18:02
 * @des
 */
import {
  isPdf, isPdfConvertibleFile, isImage, getFileExt
} from './fileutil'
import {getLocal} from '../i18n'

const Constants = require('@/base/constants')

const NATIVE_URL_FLAG = '_wx_tpl'

/**
 * 公共上传附件url
 * @param attach
 * @returns {*}
 */
export function getAttachUrl (attach) {
  var prefix = Constants.API_SERVER_URL
  prefix = prefix.slice(0, prefix.length - 1)
  return prefix + attach.url
}

/**
 * 获取公式输入url
 * @returns {string}
 */
export function getMathTypeUrl () {
  var prefix = Constants.API_SERVER_URL
  return prefix + 'wxres/static/mathtype/index.html'
}

/**
 * 获取试题详情页url
 * @returns {string}
 */
export function getQuestionDetailUrl (questionId) {
  var prefix = Constants.API_SERVER_URL
  if (Constants.DEBUG) {
    prefix = 'https://hiyiba.com/'
  }
  let q = {questionId: questionId}
  return prefix + 'k12/exercise/questiondetail?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getPaperDetailUrl (paperId) {
  var prefix = Constants.API_SERVER_URL
  let q = {paperId: paperId}
  return prefix + 'k12/exam/paper/info?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getPaperTeamplateDetailUrl (templateId) {
  var prefix = Constants.API_SERVER_URL
  let q = {templateId: templateId}
  return prefix + 'k12/exam/template/info?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getAnswerDetailUrl (answerKey) {
  var prefix = Constants.API_SERVER_URL
  let q = {answerKey: answerKey}
  return prefix + 'k12/answer/detail?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getArticelDetailUrl (articleId) {
  var prefix = Constants.API_SERVER_URL
  let q = {articleId: articleId}
  return prefix + 'k12/blog/article/detail?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getLessonDetailUrl (lessonKey) {
  var prefix = Constants.API_SERVER_URL
  let q = {lessonKey: lessonKey}
  return prefix + 'k12/lesson/detail?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getFeedbackPageUrl () {
  var prefix = Constants.API_SERVER_URL
  return prefix + 'k12/common/feedback'
}

export function getUserAllRecordsUrl (user) {
  var prefix = Constants.API_SERVER_URL
  let q = {user: user}
  return prefix + 'k12/pay/order/record?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getPlanDetailUrl (planId) {
  var prefix = Constants.API_SERVER_URL
  let q = {planId: planId}
  return prefix + 'k12/plan/detail?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getClassDetailUrl (groupkey) {
  var prefix = Constants.API_SERVER_URL
  let q = {groupkey: groupkey}
  return prefix + 'k12/exam/classwork/classhome?params=' + encodeURIComponent(JSON.stringify(q))
}

export function getQuestionShareUrl (questionId, lessonKey) {
  var prefix = Constants.API_SERVER_URL
  if (Constants.DEBUG) {
    prefix = 'https://hiyiba.com/'
  }
  let q = {
    questionId: questionId,
    lessonKey: lessonKey,
    fromType: 'webLesson'
  }
  let jsUrl = 'dist/k12/exercise/question/share.js?params=' + encodeURIComponent(JSON.stringify(q))
  return prefix + 'k12/exercise/question/share?params=' + encodeURIComponent(JSON.stringify(q)) + '&' + NATIVE_URL_FLAG + '=' + encodeURIComponent(jsUrl)
}

export function openNetFile (filename, fileurl) {
  let webNewTabUrl = fileurl
  if (window.Photo && isImage(getFileExt(filename))) {
    window.Photo.preview({
      urls: [fileurl],
      current: 0
    })
  } else {
    if (isPdf(filename)) {
      webNewTabUrl = getPdfFilePreviewUrl(fileurl)
    } else if (isPdfConvertibleFile(filename)) {
      webNewTabUrl = getPdfFilePreviewUrl(getOpenFileUrl(fileurl))
    } else {
      webNewTabUrl = getChromeFileUrl(fileurl)
    }
    webNewTabJump(webNewTabUrl)
  }
}

/**
 * 获取pdf预览地址
 * @param fileUrl
 */
export function getPdfFilePreviewUrl (fileUrl) {
  let SERVER_URL = Constants.API_SERVER_URL
  if (Constants.DEBUG) {
    SERVER_URL = 'https://hiyiba.com/'
  }
  return `${SERVER_URL}wxres/vue/pdfjs/web/viewer.html?file=${encodeURIComponent(fileUrl)}`
}

/**
 * 获取文件预览地址
 * @param fileurl
 */
export function getOpenFileUrl (fileurl) {
  return fileurl.replace('downloadfile?t=5', 'openfile?t=3')
}

export function getChromeFileUrl (fileurl) {
  return fileurl + '&p=1'
}

/**
 * web端_blank打开页面
 * @param redirectUrl
 */
export function webNewTabJump (redirectUrl) {
  webNewTabJumpWithWin(redirectUrl, createWebNewWindow())
}

/**
 * 创建window
 * @returns {Window}
 */
export function createWebNewWindow () {
  return window.open('about:blank', '_blank')
}

/**
 * web端_blank打开页面(适用点击后创建窗口,rpc请求完成后打开的场景)
 * @param redirectUrl
 * @param win
 */
export function webNewTabJumpWithWin (redirectUrl, win) {
  try {
    win.location.href = redirectUrl
  } catch (e) {
    /* const modal = weex.requireModule('modal')
     modal.alert({message: redirectUrl}) */
    window.open(redirectUrl)
  }
}

/**
 * 替换试题中图片的url
 * @param content 试题内容
 */
export function replaceQuestionImgUrl (content) {
  if (content) {
    //处理tikupic文件夹
    content = content.replace(/\/tikupic\/\//g, '/tikupic/')
    //处理//papers文件夹
    content = content.replace(/\/\/papers/g, '/papers')
    content = content.replace(/url\('/g, `url('${Constants.QUESTION_IMG_URL}`)

    if (content.indexOf('src="') != -1) {
      // src="
      //处理有的图片地址是以 / 开始，有的却没有/           Upload 目录
      content = content.replace(/src="\//g, 'src="')
      //添加前缀,不对http和data添加
      content = content.replace(/src=".{4}/g, function (match, pos, originalText) {
        let temp = match.substring(5)
        if (temp == 'http' || temp == 'data') {
          return match
        }
        return 'src="' + Constants.QUESTION_IMG_URL + '/' + temp
      })

    } else if (content.indexOf('src=\'') != -1) {
      // src='
      //处理有的图片地址是以 / 开始，有的却没有/           Upload 目录
      content = content.replace(/src='\//g, 'src=\'')
      //添加前缀,不对http和data添加
      content = content.replace(/src='.{4}/g, function (match, pos, originalText) {
        let temp = match.substring(5)
        if (temp == 'http' || temp == 'data') {
          return match
        }
        return 'src=\'' + Constants.QUESTION_IMG_URL + '/' + temp
      })
    }
  }
  return content
}

/**
 * 替换填空题的input标签为输入序号
 * @param htmlStr
 */
export function replaceQuestionInput (htmlStr) {
  /*let index=0;
   htmlStr=htmlStr.replace(/input[^<>]+/ig,(match, pos, originalText)=>{
   ++index;
   return `_${index}_`;
   });*/
  htmlStr = htmlStr.replace(/<input[^<>]+>/ig, '（ ）')
  return htmlStr
}

export function convertServerUrl (url, isThumb = true) {
  let serverUrl = ''
  if (url != null && url.startsWith('http')) {
    serverUrl = url
  } else {
    if (Constants.API_SERVER_URL === '/') {
      serverUrl = 'https://hiyiba.com/' + url
    } else {
      serverUrl = Constants.API_SERVER_URL + url
    }
  }
  serverUrl = isThumb ? addUrlParams(serverUrl, {'smallpic': 1}) : serverUrl
  return serverUrl
}

export function getUrlParams (url) {
  let params = {}
  let str = url.substr(url.indexOf('?') + 1)
  let arr = str.split('&')
  for (var i in arr) {
    let paired = arr[i].split('=')
    params[paired[0]] = decodeURIComponent(paired[1])
  }
  return params
}

/**
 * 解析传递的多参数为对象
 * @param params
 */
export function decodeParams (params) {
  let decoded = {}
  if (params) {
    decoded = JSON.parse(params)
  }
  return decoded
}

/**
 * 在url后边添加参数
 * @param url
 * @param params
 */
export function addUrlParams (url, params) {
  if (params) {
    let flag = url.indexOf('?') != -1
    for (let param in params) {
      url += flag ? '&' : '?'
      url += param + '=' + encodeURIComponent(params[param])
      flag = true
    }
  }
  return url
}

/**
 * 获取页面weburl
 * @param path  路径
 * @param params 参数{}
 * @returns {*}
 */
export function getWebUrl (path, params = {}) {
  var webUrl
  webUrl = Constants.API_SERVER_URL + path + '/'
  webUrl = addUrlParams(webUrl, params)
  return webUrl
}

/**
 * 多参数时转换成json进行参数传递
 * @param params
 */
export function encodeParams (params) {
  let encoded = {}
  if (params) {
    encoded = {params: JSON.stringify(params)}
  }
  return encoded
}

/**
 * 获取图片文件路径前缀
 * @param name 图片名
 * @returns {*}
 */
export function getImageUrl (name) {
  return require(`@/assets/images/${name}`)
}

/**
 * 替换link消息中的地址
 * @param linkUrl
 * @param lessonKey
 * @returns {*}
 */
export function replaceLessonLinkMsg (linkUrl, lessonKey) {
  if (linkUrl && lessonKey) {
    let regx = new RegExp('k12/exercise/question/share|k12/exercise/questiondetail', 'g')
    if (regx.test(linkUrl)) {
      let params = getUrlParams(linkUrl)
      if (params) {
        params = params['params']
        try {
          params = JSON.parse(params)
          let questionId = params.questionId
          linkUrl = getQuestionShareUrl(questionId, lessonKey)
        } catch (e) {
        }
      }
      // $log(linkUrl)
    }
  }
  return linkUrl
}

/**
 * 将识别出mathTex以便使用laTex转图片方式渲染
 * 注:mathJax 的公式为 \(\rm{2NaOH+CO_{2}=Na_{2}CO_{3}+H_{2}O}\)
 * 我们需要换成$\rm{2NaOH+CO_{2}=Na_{2}CO_{3}+H_{2}O}$以便使用图片方式展示该行内公式
 */
function replaceMathTex (content) {
  if (content) {
    content = content.replace(/\\\(.+?\\\)/g, function (match, pos, text) {
      let mathJax = match.substring(2, match.length - 2)
      if (mathJax == '\\rm{(}') { // 暂时解决部分latex 对\left \right的公式支持问题
        return '('
      } else if (mathJax == '\\rm{)}') {
        return ')'
      } else if (mathJax == '\\rm{[}') {
        return '['
      } else if (mathJax == '\\rm{]}') {
        return ']'
      } else if (mathJax == '\\rm{)(}') {
        return ')('
      } else {
        return `$${mathJax}$`
      }
    })
  }
  return content
}

/**
 * 显示试题内容html页面路径
 */
export function getQuestionContentHtmlUrl (id, content, htmlstyle) {
  let url = Constants.API_SERVER_URL + 'wxres/'
  if (Constants.DEBUG) {
    url = Constants.API_SERVER_URL
  }
  url += 'static/question/index.html'

  let platform = 'web'
  return url + '?id=' + encodeURIComponent(id) + '&content=' + encodeURIComponent(replaceMathTex(replaceQuestionImgUrl(content))) + '&platform=' + encodeURIComponent(platform) + '&style=' + encodeURIComponent(JSON.stringify(htmlstyle))
}

/**
 * 显示markdown内容html页面路径
 * @param id 唯一标识
 * @param htmlStyle
 * @param useLocal
 * @returns {string}
 */
export function getMarkdownContentHtmlUrl (id, htmlStyle, useLocal = false) {
  let url = Constants.API_SERVER_URL + 'wxres/'
  if (Constants.DEBUG) {
    url = Constants.API_SERVER_URL
  }
  if (useLocal) {
    url = './wxres/'
  }
  url += 'static/md/index.html'
  let platform = 'web'
  return url + '?id=' + encodeURIComponent(id) + '&platform=' + encodeURIComponent(platform) + '&style=' + encodeURIComponent(JSON.stringify(htmlStyle))
}

export function getCoursewareContentHtmlUrl (id, htmlStyle, typewriterFrequency = 100) {
  let url = Constants.API_SERVER_URL + 'wxres/'
  if (Constants.DEBUG) {
    url = Constants.API_SERVER_URL
  }
  url += 'static/courseware/index.html'
  let platform = 'web'
  let locale = getLocal()
  return url + '?id=' + encodeURIComponent(id) + '&platform=' + encodeURIComponent(platform) + '&style=' + encodeURIComponent(JSON.stringify(htmlStyle)) + '&locale=' + encodeURIComponent(locale) + '&typewriterFrequency=' + encodeURIComponent(typewriterFrequency)
}

/**
 * 可通行的链接前缀 用户过滤处理一些url
 */
export function getAccessibleUrlPrefix () {
  return Constant.API_SERVER_URL
}

export function getJsBundleQueryData () {
  let url = window.location.href
  let result = {}
  if (url) {
    let index = url.lastIndexOf('?')
    if (index !== -1) {
      url = url.substring(index)
      if (url.indexOf('?') !== -1) {
        let str = url.substr(1)
        let strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          result[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
        }
      }
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/base/util/urlutil.js